import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

export default function Com(): JSX.Element {
    
    const { t } = useTranslation('assessment');

    return (
        <>
            <h3>{t("com.title") as string}</h3>
            <p>{t("com.list-title") as string}</p>
            <ul>
                <li>{t("com.list.point-1") as string}</li>
                <li>{t("com.list.point-2") as string}</li>
                <li>{t("com.list.point-3") as string}</li>
            </ul>
            <p>{t("com.paragraph-1") as string}</p>
            <p>{t("com.paragraph-2") as string}</p>
            <p>{t("com.paragraph-3") as string}</p>
            <p>{t("com.paragraph-4") as string}<a className="bolder-text" href={t("com.hyperlink-1") as string} target="_blank" rel="noopener noreferrer">{t("com.hyperlink-text-1") as string}</a>, <a className="bolder-text" href={t("com.hyperlink-2") as string} target="_blank" rel="noopener noreferrer">{t("com.hyperlink-text-2") as string}</a>.</p>
        </>
    );
}